import { render, staticRenderFns } from "./ActualizarEmision.vue?vue&type=template&id=4b2ad8f8"
import script from "./ActualizarEmision.vue?vue&type=script&lang=js"
export * from "./ActualizarEmision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports